import React from "react";
import "./CertificateGroupingCommon.scss";
import CertificateGroupingRequestListReview from "../../features/CertificateGroupingRequestListReview/CertificateGroupingRequestListReview";

const CertificateGroupingCommonForReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingRequestListReview/>
    </div>
  );
};

export default CertificateGroupingCommonForReview;
